<style>
 .textDecoration{
  text-decoration: underline;
  color: #44bd32 !important;
  padding: 0px 5px;
 }
</style>

<template>
  <div>
    <Row>
      <i-col span="24">
        <div>
          <strong style="line-height: 45px">不计费区间</strong>
          <a class="m-l-10" @click="visible = true"><Icon type="md-add" />添加</a>
        </div>
        <Row :gutter="8">
          <i-col span="24">
            <p v-if="!freePeriodArray.length" class="remark">本合同未约定不计费区间</p>
            <div v-else>本合同约定不计费区间如下：</div>
            <p v-for="(item, index) in freePeriodArray" :key="index">
              {{ index + 1 }}.
              <label v-if="item.type === 1">
                <span class="textDecoration"
                  >{{item.coNames}}</span
                >，在
                <span class="textDecoration"> {{ item.startDate }} 至 {{ item.endDate }}</span>区间， 不计算
                <span class="textDecoration">{{ getFeeTypeName(item.feeType)}}</span>
              </label>

              <label v-else>
                <span class="textDecoration"
                  >{{item.coNames}}</span
                >，自资产交付日起
                <span class="textDecoration"> {{ item.duration }} </span>个月， 不计算
                <span class="textDecoration">{{ getFeeTypeName(item.feeType)}}</span>
              </label>

              <a class="text-blue-500" @click="deletefreePeriod(item.id)">
                <Icon type="ios-trash-outline" />移除
              </a>
            </p>
          </i-col>
        </Row>
      </i-col>
    </Row>

    <Divider dashed style="margin-bottom: 5px;"/>

    <!-- 其他费用 -->
    <Row>
      <i-col span="24">
        <div>
          <strong style="line-height: 45px">其他费用</strong>
          <a class="m-l-10" @click="showPaymentInfoModal()"><Icon type="md-add" />添加</a>
        </div>
        <Table :columns="otherFeeColumn" stripe size="small" :data="otherFeeData"></Table>
      </i-col>
    </Row>

    <row class="p-t-10">
      <i-col span="24">
        <Button type="info" @click="handlePreviousStep">上一步</Button>
        <div class="right">
          <Button type="info" @click="handleNextStep">下一步</Button>
        </div>
      </i-col>
    </row>

    <Modal v-model="visible">
      <template #header>
        <p>添加不计费区间</p>
      </template>
      <Form
        ref="freePeriodForm"
        :model="freePeriodFormModel"
        :rules="freePeriodFormModel.type === 1?freePeriodRules1:freePeriodRules2"
        :label-width="120"
      >
        <FormItem
          prop="feeType"
          label="费用类型"
        >
          <RadioGroup v-model="freePeriodFormModel.feeType">
            <Radio
              v-for="item in feeTypeArray"
              :key="item.id"
              :label="item.id"
              >{{ item.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <FormItem
          prop="type"
          label="区间类型"
        >
          <RadioGroup v-model="freePeriodFormModel.type">
            <Radio v-for="item in typeArray" :key="item.id" :label="item.id">{{
              item.name
            }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          prop="freeStartDate"
          label="开始日期"
          v-if="freePeriodFormModel.type === 1"
        >
          <DatePicker
            v-model="freePeriodFormModel.freeStartDate"
            type="date"
            placeholder="开始日期"
            class="w-full"
          />
        </FormItem>
        <FormItem
          prop="freeEndDate"
          label="结束日期"
          v-if="freePeriodFormModel.type === 1"
        >
          <DatePicker
            v-model="freePeriodFormModel.freeEndDate"
            type="date"
            placeholder="结束日期"
            class="w-full"
          />
        </FormItem>
        <FormItem
          prop="duration"
          label="周期"
          v-if="freePeriodFormModel.type === 2"
        >
          <Input
            type="text"
            v-model="freePeriodFormModel.duration"
            placeholder="周期"
          >
            <template #append>
              <span>个⽉</span>
            </template></Input
          >
        </FormItem>
        <FormItem prop="coIdArray" label="不计费范围">
          <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll">全选</Checkbox>
          <Divider style="margin: 0px;"/>

          <CheckboxGroup v-model="freePeriodFormModel.coIdArray" @on-change="checkAllCoIdChange">
            <p v-for="item in objectList" :key="item.id">
              <Checkbox :label="item.id">
                {{ item.objectName }} ({{ item.resourceTypeName }} {{ item.number }}{{ formatObjectTypeName(item.objectType) }})
              </Checkbox>
            </p>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <template #footer>
        <div class="text-right">
          <Button type="text" class="m-r-5" @click="visible = false"
            >关闭</Button
          >
          <Button type="primary" @click="handldSave">确定</Button>
        </div>
      </template>
    </Modal>

    <Modal v-model="editpaymentInfoModal">
      <template #header>
        <p>编辑其他费用</p>
      </template>
      <Form
        ref="paymentInfoForm"
        :model="paymentInfoModel"
        :rules="paymentInfoRules"
        :label-width="150"
      >
        <FormItem prop="feeName" label="费用名称">
          <Input
            v-model="paymentInfoModel.feeName"
            placeholder="请输入费用名称"
          />
        </FormItem>
        <FormItem prop="amount" label="费用金额">
          <Input
            type="number"
            v-model="paymentInfoModel.amount"
            placeholder="请输入费用金额"
          >
            <template #append>
              <span>元</span>
            </template></Input
          >
        </FormItem>
        <FormItem prop="payDate" label="付款日期">
          <DatePicker
            v-model="paymentInfoModel.payDate"
            type="date"
            placeholder="请输入付款日期"
            style="width: 100%;"
          />
        </FormItem>
        <FormItem prop="depositAmount" label="备注项">
          <Input v-model="paymentInfoModel.remark" type="textarea" maxlength="255" show-word-limit :rows="5" placeholder="请输入费用项备注信息..."></Input>
        </FormItem>
      </Form>
      <template #footer>
        <div class="text-right">
          <Button
            type="text"
            class="m-r-5"
            @click="editpaymentInfoModal = false"
            >关闭</Button
          >
          <Button type="primary" @click="handldPaymentInfoSave">确定</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script >
import { parseUpperMoney } from '@/utils/index'
import { toMoney } from '@/utils/wnumb_own'
import { ParseDate } from '@/utils/dateFormat'

import { listDictLabel } from '@/api/invest/dict'

import {
  listFreePeriod,
  addFreePeriod,
  deleteFreePeriod,
  listObjectAndFee,
  addOtherFee,
  listOtherFee,
  removeOtherFee
} from '@/api/invest/contract'

export default {
  components: {},
  props: {},
  data () {
    return {
      feeTypeArray: [],
      freePeriodArray: [],
      visible: false,
      editpaymentInfoModal: false,
      typeArray: [
        { id: 1, name: '固定日期' },
        { id: 2, name: '固定周期' }
      ],

      indeterminate: false,
      checkAll: false,

      objectList: [],

      paymentInfoModel: {
        amount: undefined,
        contractId: 0,
        feeName: '',
        payDate: null,
        remark: ''
      },
      paymentInfoRules: {
        feeName: [{ required: true, message: '请输入费用名称' }],
        amount: [{ required: true, message: '请输入费用金额' }],
        payDate: [{ required: true, message: '请输入付款时间' }]
      },

      otherFeeColumn: [
        { title: '费用名称', key: 'feeName' },
        { title: '费用金额', key: 'amount' },
        { title: '付款日期', key: 'payDate' },
        { title: '备注项', key: 'remark' },
        {
          title: '操作',
          align: 'center',
          width: 140,
          render: (h, params) => {
            const deleteButton = h(
              'a',
              {
                style: {
                  marginRight: '5px',
                  color: '#ef4f4f'
                },
                on: {
                  click: () => {
                    this.deletePayment(params.row.id)
                  }
                }
              },
              '移除'
            )

            return h('div', [deleteButton])
          }
        }
      ],
      otherFeeData: [],

      freePeriodRules1: {
        freeStartDate: [
          { required: true, message: '请选择不计费区间开始日期' }
        ],
        freeEndDate: [{ required: true, message: '请选择不计费区间结束日期' }],
        coIdArray: [
          { required: true, type: 'array', min: 1, message: '请选择不计费范围', trigger: 'change' }
        ]
      },
      freePeriodRules2: {
        duration: [{ required: true, message: '请输入不计费周期' }],
        coIdArray: [
          { required: true, type: 'array', min: 1, message: '请选择不计费范围', trigger: 'change' }
        ]
      },

      coIdArray: [],
      freePeriodFormModel: {
        contractId: 0,
        type: 1,
        coIds: [],
        coIdArray: [],
        feeType: 1,
        freeStartDate: '',
        freeEndDate: '',
        duration: undefined
      }
    }
  },
  mounted () {},
  created () {
    this.initBaseData()
    this.initFreePeriodList()
    this.initOtherFeeList()
  },
  methods: {
    initBaseData () {
      listDictLabel({ dictType: 'fee_type' }).then(res => {
        this.feeTypeArray = res.map(x => {
          return {
            id: parseInt(x.id),
            name: x.name
          }
        })
      })

      listObjectAndFee({ contractId: this.contractInfo.id }).then((res) => {
        this.objectList = res
      })

      // 参数赋值
      this.paymentInfoModel.contractId = this.contractInfo.id
    },
    formatMoney (number) {
      return toMoney(number)
    },
    formatUpperMoney (money) {
      return parseUpperMoney(money)
    },
    formatObjectTypeName (objectType) {
      let unit = ''
      if (objectType === 3007) {
        unit = ' 台'
      } else if ([3006, 3013].includes(objectType)) {
        unit = ' ㎡'
      }

      return unit
    },
    getFeeTypeName (type) {
      const fee = this.feeTypeArray.find(x => x.id === type)
      return fee ? fee.name : '未知'
    },
    initFreePeriodList () {
      listFreePeriod({ contractId: this.contractInfo.id }).then((res) => {
        this.freePeriodArray = res
      })
    },
    initOtherFeeList () {
      listOtherFee({ contractId: this.contractInfo.id }).then((res) => {
        this.otherFeeData = res
      })
    },
    handldSave () {
      this.$refs.freePeriodForm.validate((valid) => {
        if (valid) {
          this.freePeriodFormModel.contractId = this.contractInfo.id

          this.freePeriodFormModel.freeStartDate = ParseDate(
            this.freePeriodFormModel.freeStartDate
          )
          this.freePeriodFormModel.freeEndDate = ParseDate(
            this.freePeriodFormModel.freeEndDate
          )

          this.freePeriodFormModel.coIds = this.freePeriodFormModel.coIdArray.join(',')
          //   this.coIdArray.toString()

          addFreePeriod(this.freePeriodFormModel).then((res) => {
            this.visible = false
            this.initFreePeriodList()
          })
        } else {
          this.$Notice.error({ desc: '请正确输入信息' })
        }
      })
    },
    deletefreePeriod (fId) {
      this.$Modal.confirm({
        title: '删除确认',
        content: '是否删除当前免租期？',
        onOk: () => {
          deleteFreePeriod({ freeId: fId }).then((res) => {
            this.initFreePeriodList()
          })
        }
      })
    },
    showPaymentInfoModal () {
      this.paymentInfoModel.feeName = ''
      this.paymentInfoModel.amount = undefined
      this.paymentInfoModel.payDate = null
      this.paymentInfoModel.remark = ''

      this.editpaymentInfoModal = true
    },
    handldPaymentInfoSave () {
      this.$refs.paymentInfoForm.validate((valid) => {
        if (valid) {
          // 其他费用清单
          this.paymentInfoModel.payDate = ParseDate(this.paymentInfoModel.payDate)

          addOtherFee(this.paymentInfoModel).then(res => {
            if (res && res.success) {
              this.$Notice.success({ desc: '添加其他费用清单成功！' })
              this.editpaymentInfoModal = false
              this.initOtherFeeList()
            }
          })
        } else {
          this.$Notice.error({ desc: '请正确输入信息' })
        }
      })
    },
    deletePayment (fId) {
      this.$Modal.confirm({
        title: '删除确认',
        content: '是否删除当前其他费用项吗？',
        onOk: () => {
          removeOtherFee({ keyId: fId }).then((res) => {
            this.$Notice.success({ desc: '移除其他费用清单成功！' })
            this.initOtherFeeList()
          })
        }
      })
    },

    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false

      if (this.checkAll) {
        this.freePeriodFormModel.coIdArray = this.objectList.map(x => x.id)
      } else {
        this.freePeriodFormModel.coIdArray = []
      }
    },
    checkAllCoIdChange (data) {
      if (data.length === this.objectList.length) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },

    handlePreviousStep () {
      this.$store.commit('set_contract_currentStep', 'price')
      this.$store.commit('set_contract_update', new Date())
    },
    handleNextStep () {
      this.$store.commit('set_contract_currentStep', 'files')
      this.$store.commit('set_contract_update', new Date())
    }
  },
  watch: {
    beginUpdate () {}
  },
  computed: {
    contractInfo () {
      return this.$store.state.investmentContract.contractInfo
    },
    beginUpdate () {
      return this.$store.state.investmentContract.beginUpdate
    }
  }
}
</script>
